<template>
  <div class="benefits-section">
    <div class="container">
      <div class="section-header text-center aos" data-aos="fade-up">
        <div class="section-badge text-white">Our Benefits</div>
        <h2 class="text-white">Master the skills to drive your career</h2>
        <p class="text-white">
          The right course, guided by an expert mentor, can provide invaluable insights,
          practical skills
        </p>
      </div>
      <div class="row justify-content-center row-gap-4 aos" data-aos="fade-up">
        <div class="col-md-6 col-lg-4">
          <div class="benefits-item">
            <div class="benefits-img">
              <img
                src="@/assets/img/icons/benefit-icon-01.svg"
                alt="img"
                class="img-fluid"
              />
            </div>
            <h5 class="title">Stay motivated with instructors</h5>
            <p class="text-light mb-0">
              Stay motivated with engaging instructors on our platform, guiding you
              through every course.
            </p>
          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="benefits-item">
            <div class="benefits-img">
              <img
                src="@/assets/img/icons/benefit-icon-02.svg"
                alt="img"
                class="img-fluid"
              />
            </div>
            <h5 class="title">Get certified on courses</h5>
            <p class="text-light mb-0">
              Get certified, master modern tech skills, and level up your career whether
              you’re starting.
            </p>
          </div>
        </div>
        <div class="col-md-6 col-lg-4">
          <div class="benefits-item">
            <div class="benefits-img">
              <img
                src="@/assets/img/icons/benefit-icon-03.svg"
                alt="img"
                class="img-fluid"
              />
            </div>
            <h5 class="title">Build skills on your way</h5>
            <p class="text-light mb-0">
              Build skills your way with hands-on labs and immersive courses, tailored to
              fit.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
